// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"41809501","165":"8dd535f4","227":"02a8e6e8","440":"dd91b199","519":"3c1970e6","579":"00f0ece1","645":"00931048","893":"87a083d7","925":"e0fd88a8","945":"7b88d46d","982":"efc25309"}[chunkId] + ".chunk.js";
};